export const useLinks = () => {
  const { linksFiltered } = storeToRefs(useAppearanceStore());

  const {
    hideExternalLinks: hideExternalLinksEnv,
    showGameListTitles: showGameListTitlesEnv,
  } = useRuntimeConfig().public;

  const linkToHelpCenter = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_HELP_CENTER',
      )?.link_value ?? ''
    );
  });

  const linkToAppDownload = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_APP_DOWNLOAD',
      )?.link_value ?? ''
    );
  });

  const linkToBlog = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_BLOG',
      )?.link_value ?? ''
    );
  });

  const useCoreBlog = computed<boolean>(() => {
    const value = linksFiltered.value
      ?.find((item: AppearanceLinks) => item.link_title === 'USE_CORE_BLOG')
      ?.link_value?.toLowerCase()
      ?.trim();

    return value !== 'false' && value !== '0';
  });

  const useCorePromotions = computed<boolean>(() => {
    const value = linksFiltered.value
      ?.find(
        (item: AppearanceLinks) => item.link_title === 'USE_CORE_PROMOTIONS',
      )
      ?.link_value?.toLowerCase()
      ?.trim();

    return value !== 'false' && value !== '0';
  });

  const blogUrlWpApi = computed<string>(() => {
    const blogUrl = linkToBlog.value;

    if (!blogUrl) return '';

    // Se contém localhost ou devtunnels, usa o blog fixo
    if (
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.includes('devtunnels'))
    ) {
      return 'https://blog.apostatudo.bet.br/wp-json/wp/v2/posts';
    }

    // Constrói a URL da API do WordPress
    try {
      const url = new URL(blogUrl);

      return `${url.origin}/wp-json/wp/v2/posts`;
    } catch {
      return '';
    }
  });

  const hideExternalLinks = computed<boolean>(() => {
    return !!hideExternalLinksEnv;
  });

  const showGameListTitles = computed<boolean>(() => {
    return !!showGameListTitlesEnv;
  });

  const finalLinkToBlog = computed<string>(() => {
    if (useCoreBlog.value || blogUrlWpApi.value) {
      return localeLink('/blog');
    }

    if (hideExternalLinks.value) {
      return '';
    }

    return linkToBlog.value || '';
  });

  const linkToBlogTargetBlank = computed<boolean>(() => {
    if (useCoreBlog.value || blogUrlWpApi.value) {
      return false;
    }

    return !!linkToBlog.value;
  });

  const linkToAffiliates = computed<string>(() => {
    if (hideExternalLinks.value) {
      return '';
    }

    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_AFFILIATES',
      )?.link_value ?? ''
    );
  });

  const linkToAffiliatesLabel = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) =>
          item.link_title === 'LINK_TO_AFFILIATES_LABEL',
      )?.link_value ?? ''
    );
  });

  const linkToTelegram = computed<string>(() => {
    if (hideExternalLinks.value) {
      return '';
    }

    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_TELEGRAM',
      )?.link_value ?? ''
    );
  });

  const linkToTelegramLabel = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_TELEGRAM_LABEL',
      )?.link_value ?? ''
    );
  });

  const linkToReclameAqui = computed<string>(() => {
    if (hideExternalLinks.value) {
      return '';
    }

    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_RECLAME_AQUI',
      )?.link_value ?? ''
    );
  });

  const linkCustomUserMenu = computed<string>(() => {
    if (hideExternalLinks.value) {
      return '';
    }

    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_CUSTOM_USER_MENU',
      )?.link_value ?? ''
    );
  });

  const linkCustomUserMenuLabel = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) =>
          item.link_title === 'LINK_CUSTOM_USER_MENU_LABEL',
      )?.link_value ?? ''
    );
  });

  const linkToPromotions = computed<string>(() => {
    if (hideExternalLinks.value) {
      return '';
    }

    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'LINK_TO_PROMOTIONS',
      )?.link_value ?? ''
    );
  });

  const promotionsUrlIframe = computed<string>(() => {
    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'PROMOTIONS_IFRAME',
      )?.link_value ?? ''
    );
  });

  const promotionsUrlWpApi = computed<string>(() => {
    const promotionsUrl =
      linksFiltered.value?.find(
        (item: AppearanceLinks) => item.link_title === 'PROMOTIONS_WP_API',
      )?.link_value ?? '';

    if (
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.includes('devtunnels'))
    ) {
      return 'https://blog.apostatudo.bet.br/wp-json/wp/v2/posts?categories=187&per_page=50&filter[orderby]=date&order=desc';
    }

    return promotionsUrl;
  });

  const finalLinkToPromotions = computed<string>(() => {
    if (
      useCorePromotions.value ||
      promotionsUrlWpApi.value ||
      promotionsUrlIframe.value
    ) {
      return localeLink('/promotions');
    }

    if (hideExternalLinks.value) {
      return '';
    }

    return linkToPromotions.value || '';
  });

  const linkToPromotionsTargetBlank = computed<boolean>(() => {
    if (
      useCorePromotions.value ||
      promotionsUrlWpApi.value ||
      promotionsUrlIframe.value
    ) {
      return false;
    }

    return !!linkToPromotions.value;
  });

  const linkToResponsibleGaming = computed<string>(() => {
    // return 'https://www.google.com';

    return (
      linksFiltered.value?.find(
        (item: AppearanceLinks) =>
          item.link_title === 'LINK_TO_RESPONSIBLE_GAMING',
      )?.link_value ?? ''
    );
  });

  const linkToCentralizedExclusion = computed<string>(() => {
    return 'https://gov.br/autoexclusaoapostas';
  });

  return {
    linkToHelpCenter,
    linkToAppDownload,
    linkToBlog,
    blogUrlWpApi,
    useCoreBlog,
    finalLinkToBlog,
    linkToBlogTargetBlank,
    linkToAffiliates,
    linkToAffiliatesLabel,
    linkToTelegram,
    linkToTelegramLabel,
    linkToReclameAqui,
    linkCustomUserMenu,
    linkCustomUserMenuLabel,
    hideExternalLinks,
    showGameListTitles,
    linkToPromotions,
    useCorePromotions,
    promotionsUrlIframe,
    promotionsUrlWpApi,
    finalLinkToPromotions,
    linkToPromotionsTargetBlank,
    linkToResponsibleGaming,
    linkToCentralizedExclusion,
  };
};
